import { useCallback, useEffect, useMemo, useState } from "react";
import { AxiosRequest } from "_services/api";
import { HttpError } from "_services/api/HttpError";
import { HttpResponse } from "_services/api/HttpResponse";
import {
  IData,
  IHttpError,
  IHttpResponse,
} from "_services/api/interface/HttpResponse";

export function useEmpresas(filtrarComECnpj: boolean = false) {
  const [empresas, setEmpresas] = useState<any[]>([]);
  const [empresasOptions, setEmpresasOptions] = useState<any[]>([]);
  const [cnpjsOptions, setCnpjsOptions] = useState<any[]>([]);
  const [error, setError] = useState<IHttpResponse<IData | any>>();
  const [loading, setLoading] = useState(true);

  const api = useMemo(() => AxiosRequest.makeApi(), []);
  const msAw = AxiosRequest.makeApi(process.env.REACT_APP_MS_AW);

  const listarTodasEmpresas = useCallback(async () => {
    setLoading(true);
    try {
      const { status, data } = await api.get("/empresa/");
      const rersponse = new HttpResponse(false, status, data);
      setError(rersponse);
      setEmpresas(data.dados);
      criarOptionsEmpresas(data.dados);
      return rersponse;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      return response;
    } finally {
      setLoading(false);
    }
  }, [api]);

  useEffect(() => {
    listarTodasEmpresas();
  }, [listarTodasEmpresas]);

  function criarOptionsEmpresas(empresas: any[]) {
    const optionsEmpresas = empresas
      .filter((item) => {
        if (!filtrarComECnpj) {
          return true;
        }

        return item.temCredenciaisECnpj;
      })
      .map((item) => ({
        value: item.id,
        label: item.razao_social,
      }));

    setEmpresasOptions(optionsEmpresas);
    return optionsEmpresas;
  }

  const listarCnpjsIntegracaoFrotista = async (idEmpresa: number) => {
    if (!idEmpresa) {
      criarOptionsCnpjs([]);
      return;
    }
    try {
      const { status, data } = await msAw.get(
        `credenciais/frotista/pr/empresa/${idEmpresa}`,
      );
      const rersponse = new HttpResponse(false, status, data);
      setError(rersponse);
      criarOptionsCnpjs(data);
      return rersponse;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      criarOptionsCnpjs([]);
      return response;
    }
  };

  function criarOptionsCnpjs(cnpjs: any[]) {
    const optionsCnpjs = cnpjs.map((item) => ({
      value: item.cnpj,
      label: item.cnpj,
    }));

    setCnpjsOptions(optionsCnpjs);
    return optionsCnpjs;
  }

  return {
    empresas,
    error,
    empresasOptions,
    criarOptionsEmpresas,
    listarCnpjsIntegracaoFrotista,
    cnpjsOptions,
    loading,
  };
}
